import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { ModifiedTirePartItem } from "../Results/useTireResults";

export const getTirePartNumber = (
  part?: ModifiedTirePartItem | TirePartItem | null
): null | string =>
  part?.partDetails.primaryPart.tireNationalPartNumber?.trim() ||
  part?.partDetails.primaryPart.tireManufacturerPartNumber ||
  null;
